import type {
  FormSegment,
  Group,
  LookalikeFormSegment,
} from '../../../../../../../../modules/audiences/AudienceForm/types';
import { MatchingOperator } from '../../../../../constants';
import { isGroup } from '../../utils/guards';

export type CreateGroupParams = {
  baseValues: Group;
  segments: {
    directSegments: FormSegment[];
    rtgSegments: FormSegment[];
    thirdPartySegments: FormSegment[];
    siteCategorySegments: FormSegment[];
    oxPurchaseSegments: FormSegment[];
    lookalikeSegments: LookalikeFormSegment[];
  };
};

export const createGroup = ({ baseValues, segments }: CreateGroupParams): Group => {
  const {
    directSegments,
    rtgSegments,
    thirdPartySegments,
    siteCategorySegments,
    oxPurchaseSegments,
    lookalikeSegments,
  } = segments;

  return {
    uuid: baseValues.uuid,
    operator: baseValues.operator,

    ...(isGroup(baseValues) &&
      baseValues.region != null && {
        region: baseValues.region,
        countries: baseValues.countries ?? null,
      }),

    ...(isGroup(baseValues) && baseValues.location && { location: baseValues.location }),
    ...(isGroup(baseValues) && baseValues.demographic_age && { demographic_age: baseValues.demographic_age }),
    ...(isGroup(baseValues) && baseValues.demographic_gender && { demographic_gender: baseValues.demographic_gender }),

    ...(directSegments.length > 0 && {
      direct: {
        segments: directSegments,
        operator: isGroup(baseValues)
          ? (baseValues.direct?.operator ?? MatchingOperator.UNION)
          : MatchingOperator.UNION,
      },
    }),

    ...(rtgSegments.length + thirdPartySegments.length + siteCategorySegments.length + oxPurchaseSegments.length >
      0 && {
      predefined: {
        segments: [...rtgSegments, ...thirdPartySegments, ...siteCategorySegments, ...oxPurchaseSegments],
        operator: isGroup(baseValues)
          ? (baseValues.predefined?.operator ?? MatchingOperator.UNION)
          : MatchingOperator.UNION,
      },
    }),

    ...(lookalikeSegments.length > 0 && {
      lookalike: {
        segments: lookalikeSegments,
        operator:
          isGroup(baseValues) && baseValues.lookalike?.operator
            ? baseValues.lookalike?.operator
            : MatchingOperator.UNION,
      },
    }),
  };
};
